import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './share_campaign_textarea.less'
import { getI18n } from 'client/i18n'
import Clipboard from 'clipboard'
import FirstChild from 'components/common/first_child'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { DESCRIPTION_ROWS, SHARE_MESSAGE_LENGTH } from 'shared/lengths'
import { Icon, TextArea, Link } from '@paypalcorp/pp-react'
import { trackClick } from 'lib/fpti_analytics'

import {
  EmailSharing,
  TwitterSharing,
  FacebookSharing,
  MessengerSharing,
  WhatsAppSharing,
  SmsSharing,
} from 'components/common/share_buttons'

const TOOLTIP_SHOW_DELAY = 750
const TOOLTIP_ANIMATION_DURATION = 250

const i18n = getI18n('components/share_campaign_textarea')

class ShareCampaignTextarea extends React.Component {
  static propTypes = {
    shareUrl: PropTypes.string.isRequired,
    displayUrl: PropTypes.string.isRequired,
    shareable: PropTypes.bool.isRequired,
    appId: PropTypes.number.isRequired,

    onClickOverride: PropTypes.func,

    showFacebook: PropTypes.bool,
    showMessenger: PropTypes.bool,
    showTwitter: PropTypes.bool,
    showWhatsApp: PropTypes.bool,
    showEmail: PropTypes.bool,
    showSms: PropTypes.bool,
    showSubtext: PropTypes.bool,
    description: PropTypes.string,
    styles: PropTypes.object,
    isMobile: PropTypes.bool,
    textPlaceholder: PropTypes.string,
    charity: PropTypes.object,
  }

  static defaultProps = {
    shareable: true,
    showFacebook: true,
    showMessenger: true,
    showTwitter: true,
    showWhatsApp: true,
    showEmail: true,
    showSms: true,
    showSubtext: false,
    isMobile: false,
  }

  state = {
    copyText: this.props.description || this.props.displayUrl,
    showTooltip: false,
    errorMsg: false,
  }

  componentDidMount() {
    if (this.props.shareable) {
      this.clipboard = new Clipboard(this.copyLink, {
        text: () => this.state.copyText,
      })
      this.clipboard.on('success', this.handleCopySuccess)
    }
  }

  componentWillUnmount() {
    if (this.clipboard) {
      this.clipboard.destroy()
    }
  }

  copyValidation = () => {
    if (this.state.copyText === '') {
      this.setState({ errorMsg: true })
    } else {
      this.setState({ errorMsg: false })
    }
    const charity = this.props.charity
    trackClick({
      clickName: 'copy',
      data: {
        event_name: 'dw_giving_share_channel_pressed',
        link_name: 'copy',
        flow:
          charity && charity.name
            ? 'GENEROSITY_NETWORK_CHARITIES'
            : 'GENEROSITY_NETWORK',
        charityname: charity && charity.name,
        crid: charity && charity.nonprofit_id,
      },
    })
  }

  handleChange = event => {
    this.setState({ copyText: event.target.value, errorMsg: false })
  }

  handleCopySuccess = e => {
    this.setState({ showTooltip: true })
    setTimeout(() => {
      this.setState({ showTooltip: false })
    }, TOOLTIP_SHOW_DELAY)
  }

  render() {
    const transitionNames = {
      enter: this.props.styles['tooltip-enter'],
      enterActive: this.props.styles['tooltip-enter-active'],
      leave: this.props.styles['tooltip-leave'],
      leaveActive: this.props.styles['tooltip-leave-active'],
    }

    return (
      <div>
        <TextArea
          styleName={`copy-textarea ${this.state.errorMsg ? 'error' : ''}`}
          label={this.props.textPlaceholder}
          minRows={DESCRIPTION_ROWS}
          maxCharacters={SHARE_MESSAGE_LENGTH}
          value={this.state.copyText}
          onChange={this.handleChange}
          onBlur={this.copyValidation}
          aria-label="copy textarea"
          showCharacterCounter
        />
        {this.state.errorMsg && (
          <>
            <span styleName="errorMsg">{i18n('error')}</span>
          </>
        )}
        <div styleName="share-icons">
          <EmailSharing
            {...this.props}
            shareText={this.state.copyText}
            className={styles['share-icon']}
          />

          {this.props.isMobile && (
            <SmsSharing
              {...this.props}
              shareText={this.state.copyText}
              className={styles['share-icon']}
            />
          )}

          <FacebookSharing {...this.props} className={styles['share-icon']} />

          <TwitterSharing
            {...this.props}
            shareText={this.state.copyText}
            className={styles['share-icon']}
          />

          <MessengerSharing {...this.props} className={styles['share-icon']} />

          <WhatsAppSharing
            {...this.props}
            shareText={this.state.copyText}
            className={styles['share-icon']}
          />

          <div styleName="copy-box-wrapper share-icon">
            <Link
              styleName="copy-wrapper"
              data-nemo="copy"
              href="javascript:;"
              ref={copyLink => {
                this.copyLink = copyLink
              }}
              onClick={this.copyValidation}
              title="copy"
            >
              <Icon name="share-link" size="xl" />
            </Link>
            {this.props.showSubtext && (
              <div styleName="sub-text">{i18n('copy')}</div>
            )}
            <ReactCSSTransitionGroup
              component={FirstChild}
              transitionName={transitionNames}
              transitionEnterTimeout={TOOLTIP_ANIMATION_DURATION}
              transitionLeaveTimeout={TOOLTIP_ANIMATION_DURATION}
            >
              {this.state.showTooltip && (
                <div styleName="copied-tooltip">{i18n('copied')}</div>
              )}
            </ReactCSSTransitionGroup>
          </div>
        </div>
      </div>
    )
  }
}

export default cssModules(ShareCampaignTextarea, styles, {
  allowMultiple: true,
})
